import {
  Injectable,
  ComponentFactoryResolver,
  Injector,
  ApplicationRef,
  EmbeddedViewRef
} from '@angular/core';
import { Overlay } from '@angular/cdk/overlay';
import { MessageContainerComponent } from '@root/router/component/message/message-container/message-container.component';
enum Position {
  RIGHT = 'right',
  CENTER = 'center'
}

export enum Type {
  SYNC = 1,
  CALENDAR = 2,
  PRICE_DAILY = 3,
  PRICE_WEEK = 4,
  XIAOZHU_ORDER = 5,
  MANUAL_ORDER = 6,
  HOUSEORIGIN_ORDER = 7,

  HOUSE_STATUS = 10,
  RESERVATION_CONFLICT = 11,
  LOSE_CONNECTION = 12,
  CUSTOM_DAILY_PRICE = 13,
  BOTH_PRICE_AND_STATUS = 14,
  BASIC_PRICE = 15,
  SUB_ACCOUNT = 16,

  RELEASE_FAILED = 17,
  RELEASE_SUCCESS = 18,
  STORE_APPROVED = 19,
  STORE_REJECTED = 20,
  APPROVED = 21,
  REJECTED = 22,
  AIRBNB_HOUSE_CHANGE = 24,
  RESERVATION_CANCEL = 25,
  SYSTEM_NOTICE = 26,
  SYNC_HOUSE_CALENDAR = 27,
  SYNC_ACCOUNT_RESERVATIONS = 28,
  SYNC_SINGLE_HOUSE = 29,
  CUSTOMER_INQUIRY = 30,
  RESERVATION_ACCEPTED = 31,
  RESERVATION_HOUSE_STATUS_FAILED = 32,

  RESERVATION_V2 = 50 /** 该字段将代替以上所有reservation相关的字段 */,

  SYNC_CALENDAR_BY_ACCOUNT = 51 /** 按渠道读取日历 */,

  CLEAN_TASK = 52 /** 保洁任务相关 */,

  TUJIA_AUTO_ACCEPT = 53 /** 途家自动接单 */,

  DEFAULT = 1024 /** 默认 */
}
export enum Status {
  DOING = 1,
  SUCCESS = 2,
  FAIL = 3,
  WARNING = 4,
  INFO = 5
}

export const StatusMap = {
  success: Status.SUCCESS,
  error: Status.FAIL,
  warning: Status.WARNING,
  info: Status.INFO
};

export class NotifyModel {
  type: Type;
  status: Status;
  /**
   * title和content将逐渐用来替换掉payload里的title和desc
   * 由于所有的显示可以交给后端控制，前端没有必要再拼接数据
   * payload将逐渐废弃掉
   */
  title?: string;
  content?: string;
  show?: boolean;
  payload?: any; // { title: '', desc: '', list: [ {} ] }
  btns?: Array<{ text: string; cb: Function }>;
  constructor(options) {
    this.type = options.type;
    this.status = options.status;
    this.title = options.title;
    this.content = options.content || ''
    this.payload = options.payload;
    this.btns = options.btns;
    this.show = true;

    // if (this.content.length > 40) {
    //   this.content = this.content.slice(0, 40) + '...'
    // }
  }
}

@Injectable({
  providedIn: 'root'
})
export class MessageService {
  container: MessageContainerComponent;
  constructor(
    private overlay: Overlay,
    private injector: Injector,
    private appRef: ApplicationRef,
    private cfr: ComponentFactoryResolver
  ) {
    this.container = this.createContainer();
  }

  initMessageContainer () {
    // console.log('initMessageContainer');
    // this.container = this.createContainer();
    // console.log('initMessageContainer ent');
  }

  createContainer() {
    const factory = this.cfr.resolveComponentFactory(MessageContainerComponent);
    const componentRef = factory.create(this.injector);
    this.appRef.attachView(componentRef.hostView);
    const overlayPane = this.overlay.create().overlayElement;
    overlayPane.appendChild((componentRef.hostView as EmbeddedViewRef<{}>)
      .rootNodes[0] as HTMLElement);
    return componentRef.instance;
  }

  createMessage(messageData, option?) {
    this.container.createMessage(messageData, option);
  }

  remove(messageId: number, option?) {
    if (messageId) {
      this.container.removeMessage(messageId, option);
    } else {
      this.container.removeMessageAll();
    }
  }

  clear() {
    this.container.removeMessageAll();
  }

  replace(messageId: number, messageData, option?) {
    this.container.replaceMessage(messageId, messageData, option);
  }

  create(messageData, option?) {
    return this.createMessage(messageData, option);
  }
}
